<app-base-outbox-messages
[modelWithPagination]="modelWithPagination$"
[items]="items$"
[getTableDataApiMethodName]="getTableDataApiMethodName"
[getTotalCountApiMethodName]="getTotalCountApiMethodName"
[pageTitle]="pageTitle"
pageId="app-user-outbox-messages"
[pageTagName]="tagName"
[excelType]="excelType"
[tabName]="tabName"
>
</app-base-outbox-messages>
